import { render, staticRenderFns } from "./RegionalReport.vue?vue&type=template&id=64cebe0a&scoped=true"
import script from "./RegionalReport.vue?vue&type=script&lang=js"
export * from "./RegionalReport.vue?vue&type=script&lang=js"
import style0 from "./RegionalReport.vue?vue&type=style&index=0&id=64cebe0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cebe0a",
  null
  
)

export default component.exports